import React, { FC } from 'react';
import { connect } from 'react-redux';
import { trackEvent } from 'dibs-tracking';
import LogoIcon from 'dibs-icons/exports/Logo';
import LogoTradeIcon from 'dibs-icons/exports/LogoTrade';
import Logo2020 from 'dibs-icons/exports/Logo2020';
import Logo2020Trade from 'dibs-icons/exports/Logo2020Trade';
import LogoVip from 'dibs-icons/exports/LogoVip';
import styles from './LogoNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo',
};

type PropsFromState = {
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    brandRefreshBuyerLogo?: boolean;
};

type Props = {
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    brandRefreshBuyerLogo?: boolean;
};
const Logo: FC<Props> = ({ isUserTypeTrade, isUserTypeVip, brandRefreshBuyerLogo }) => {
    let logo = null;
    let linkClass = null;
    if (brandRefreshBuyerLogo) {
        linkClass = styles.iconWrapper2020;
        logo = <Logo2020 />;
        if (isUserTypeTrade) {
            logo = <Logo2020Trade />;
        } else if (isUserTypeVip) {
            logo = <LogoVip />;
        }
    } else {
        logo = (
            <>
                {isUserTypeTrade ? (
                    <LogoTradeIcon />
                ) : (
                    <LogoIcon className={styles.nonTradeIconHeightFix} />
                )}
                {/* We do not want this INTL'd to preserve text proportions */}
                {!isUserTypeTrade && isUserTypeVip && (
                    <div className={styles.vipText}>PRIVATE CLIENT</div>
                )}
            </>
        );
        linkClass = styles.iconWrapper;
    }
    return (
        <div className={styles.wrapper}>
            <a
                aria-label="1stdibs"
                href="/"
                className={linkClass}
                onClick={() => {
                    trackEvent(trackingObj);
                }}
            >
                {logo}
            </a>
        </div>
    );
};

type PartialState = {
    header: Props;
};

const mapStateToProps = (state: PartialState): PropsFromState => {
    const { isUserTypeTrade, isUserTypeVip, brandRefreshBuyerLogo } = state.header;
    return {
        isUserTypeTrade,
        isUserTypeVip,
        brandRefreshBuyerLogo,
    };
};

export default connect(mapStateToProps)(Logo);
